import { Type } from '@angular/core';
import { CreateEditEndpointComponent } from './create-edit-endpoint.component';


export const CREATE_EDIT_ENDPOINT_DIRECTIVES: Type<any>[] = [
  CreateEditEndpointComponent
];
